var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15103_14989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 112C25.072 112 -7.59948e-06 86.928 -4.89568e-06 56C-2.19187e-06 25.072 25.072 -7.59948e-06 56 -4.89568e-06C86.928 -2.19187e-06 112 25.072 112 56C111.967 86.9142 86.9142 111.967 56 112ZM60.6666 28C60.6666 25.4227 58.5773 23.3334 56 23.3334C53.4227 23.3334 51.3334 25.4227 51.3334 28L51.3334 65.3334C51.3334 67.9107 53.4227 70 56 70C58.5773 70 60.6666 67.9107 60.6666 65.3334L60.6666 28ZM56 84C53.4227 84 51.3334 86.0893 51.3334 88.6666C51.3334 91.2439 53.4227 93.3332 56 93.3332C58.5773 93.3332 60.6666 91.2439 60.6666 88.6666C60.6666 86.0893 58.5773 84 56 84Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15103_14989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 112 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmDanger);
export default __webpack_public_path__ + "static/media/confirm-danger.ef73413bd7ec34ff15e44de099fb9899.svg";
export { ForwardRef as ReactComponent };